import { addSpacesBetweenWords, CfGa, RouteName } from 'common';
import { useEffect } from 'react';
import { useGa } from './useGa';

export const usePageTracking = (pathname: string, route: RouteName): void => {
  const ga = useGa() as CfGa;
  useEffect(() => ga && ga.pageview(pathname, addSpacesBetweenWords(route)), [ga, pathname, route]);
};
